import React from 'react';
import VehicleCard from './VehicleCard';
import StageStatStrip from './StageStatStrip';

const StageColumn = ({ stage, vehicles, currentTime, isFocusMode }) => {
  const isBottleneck = vehicles.length >= stage.capacity;

  return (
    <div
      className={`flex flex-col border transition-colors duration-500 ${
        isFocusMode ? 'border-white/5' : 'border-white/10'
      } bg-white/[0.01] overflow-hidden h-full`}
    >
      <div className={`p-4 border-b border-white/10 ${isBottleneck ? 'bg-[#D71921]/10' : ''}`}>
        <div className="flex justify-between items-baseline mb-1">
          <h3 className="font-mono-tech text-[11px] font-bold text-white uppercase tracking-widest">
            {stage.name.replace(' ', '_')}
          </h3>
          <span className={`font-mono-tech text-[10px] ${isBottleneck ? 'text-[#D71921]' : 'text-neutral-500'}`}>
            ({vehicles.length}/{stage.capacity})
          </span>
        </div>
        <div className="w-full bg-white/5 h-[2px] mt-3">
          <div
            className={`h-full transition-all duration-500 ${isBottleneck ? 'bg-[#D71921]' : 'bg-white/40'}`}
            style={{ width: `${Math.min((vehicles.length / stage.capacity) * 100, 100)}%` }}
          />
        </div>
      </div>

      <StageStatStrip stage={stage} vehicles={vehicles} currentTime={currentTime} />

      <div className="flex-1 overflow-y-auto p-3 custom-scrollbar">
        {vehicles.length === 0 ? (
          <div className="h-20 flex items-center justify-center opacity-10">
            <span className="font-mono-tech text-[10px] uppercase tracking-widest">Empty</span>
          </div>
        ) : (
          <div className="space-y-2">
            {vehicles.map((vehicle) => (
              <VehicleCard
                key={vehicle.id}
                vehicle={vehicle}
                currentStage={stage}
                currentTime={currentTime}
                isFocusMode={isFocusMode}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default StageColumn;
